import { useQuery } from '@tanstack/react-query';
import { PRIVILEGES } from '@stayon/auth-core';
import { useApi } from '@/shared/api';
import { can, useAuth } from '@/shared/auth';
import { PortalBrandingPanel } from '../portal-branding/PortalBrandingPanel';
import { useObjectDetail } from './ObjectDetailContext';

/** Bereich „Gastportal": Marke und Vorschau; die Inhalte bleiben in ihren Bereichen. */
export function ObjectGuestPortalTab() {
  const { groupId, canEdit: canOpenSources } = useObjectDetail();
  const api = useApi();
  const editable = can(useAuth().user, PRIVILEGES.guestExperienceEdit);
  const group = useQuery({
    queryKey: ['property-groups', groupId],
    queryFn: () => api.propertyGroups.get(groupId),
  });

  if (!group.data) return null;
  return (
    <PortalBrandingPanel group={group.data} editable={editable} canOpenSources={canOpenSources} />
  );
}
